import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import utils from 'Common/utils';

export default class extends Controller {
  static targets = ['container', 'startDate', 'endDate', 'method'];

  connect() {
    // Get the initial data right now
    this.refresh();
  }

  refresh() {
    const startDate = this.startDateTarget.value;
    const endDate = this.endDateTarget.value;
    const method = this.methodTarget.value;

    if (!utils.dateStringIsValid(startDate)) {
      this.startDateTarget.setCustomValidity('Invalid date');
      return;
    }

    if (!utils.dateStringIsValid(endDate)) {
      this.endDateTarget.setCustomValidity('Invalid date');
      return;
    }

    this.startDateTarget.setCustomValidity('');
    this.endDateTarget.setCustomValidity('');

    this.loadData(startDate, endDate, method);
  }

  loadData(startDate, endDate, method) {
    const controller = this;

    $.ajax({
      type: 'GET',
      url: controller.data.get('url'),
      dataType: 'html',
      data: {
        start: startDate,
        end: endDate,
        method,
      },
      success(data) {
        controller.containerTarget.innerHTML = data;
      },
    });
  }
}
